/**
 * MainBackground component
 */
import AccentMask from '@components/atoms/mask/accentMask';
import ContentMask from '@components/atoms/mask/sliderMask';
import DescriptionBackground from './descriptionBackground';
import MainBackgroundContainer from '@components/atoms/container/mainBackgroundContainer';
import { appSelector } from '@shared/store/slices/app.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * This component displays several masks that cover the background of the app.
 */
export default function MainBackground() {
  // ------------------------------------------------------------
  // Variables
  // ------------------------------------------------------------

  const { status } = useAppSelector(appSelector);

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return (
    <MainBackgroundContainer>
      <DescriptionBackground />
      <ContentMask display={status.sliders} />
      <AccentMask />
    </MainBackgroundContainer>
  );
}
